import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["defs",{"key":"svg-defs"}],["path",{"d":"M287 258h928v844H287z","mask":"url(#avalanche-alt-mono_svg__a)","key":"svg-path"}]]);